import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=7a052ea4&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=7a052ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a052ea4",
  null
  
)

export default component.exports